var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-section',{staticClass:"al-cv-experience",attrs:{"section":_vm.experiences}},_vm._l((_vm.experiences.content),function(xp,idx){return _c('cv-experience',{key:("al-cv-xp-" + idx),attrs:{"experience":xp}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }